export default __webpack_public_path__ + "img/oac-70eba247.png";